export enum ChangesPlanningSection {
  FinancialPlan = 'Financial Plan',
  SOBPlan = 'SOB Plan',
  UnitsPlan = 'Units Plan',
}

export interface IPlanChangeLog {
  Modified: string
  ModifiedBy: string
  PlanningSection: ChangesPlanningSection
  ProgramType: string
  Category: string
  SubCategory: string
  L3Category: string
  PlanCYQ1: string
  PlanCYQ2: string
  PlanCYQ3: string
  PlanCYQ4: string
  PlanCY: string
  PlanNY: string
  PlanN2Y: string
}
